import { render, staticRenderFns } from "./OfertarForm.vue?vue&type=template&id=2815c1fe&scoped=true"
import script from "./OfertarForm.vue?vue&type=script&lang=ts"
export * from "./OfertarForm.vue?vue&type=script&lang=ts"
import style0 from "./OfertarForm.vue?vue&type=style&index=0&id=2815c1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815c1fe",
  null
  
)

export default component.exports